"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var xstream_1 = require("xstream");
var adapt_1 = require("@cycle/run/lib/adapt");
function makeThrottleAnimation(timeSource, schedule, currentTime) {
    return function throttleAnimation(stream) {
        var source = timeSource();
        var throttledStream = xstream_1.default.create({
            start: function (listener) {
                var lastValue = null;
                var emittedLastValue = true;
                var frame$ = xstream_1.default.fromObservable(source.animationFrames());
                var animationListener = {
                    next: function (event) {
                        if (!emittedLastValue) {
                            schedule.next(listener, currentTime(), lastValue);
                            emittedLastValue = true;
                        }
                    }
                };
                xstream_1.default.fromObservable(stream).addListener({
                    next: function (event) {
                        lastValue = event;
                        emittedLastValue = false;
                    },
                    error: function (err) {
                        schedule.error(listener, currentTime(), err);
                    },
                    complete: function () {
                        frame$.removeListener(animationListener);
                        schedule.completion(listener, currentTime());
                    }
                });
                frame$.addListener(animationListener);
            },
            stop: function () { }
        });
        return adapt_1.adapt(throttledStream);
    };
}
exports.makeThrottleAnimation = makeThrottleAnimation;



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/@cycle/time/dist/throttle-animation.js
// module id = ../../../node_modules/@cycle/time/dist/throttle-animation.js
// module chunks = 1